export default __webpack_public_path__ + "static/uxbanner-051e2355bcbb5cf35f387aa7e577fa68.jpg";